import React, { memo, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AppContext } from 'src/components/app-context';

import { Button } from 'src/components/button';

const Undo = ({ undo, dispatch }) => {
  const { t } = useContext(AppContext);
  const handleClick = useCallback(() => dispatch(undo), [undo, dispatch]);

  return (
    <Button variant="link" color="positive" onClick={handleClick}>
      {t('common', 'button.undo')}
    </Button>
  );
};

Undo.propTypes = {
  undo: PropTypes.shape({
    type: PropTypes.string,
    restoreToken: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect()(memo(Undo));
